import React, {useCallback, useState} from "react";
import classNames from "classnames";
import {useSelector, useDispatch} from "react-redux";
import ReactGA from 'react-ga';

import {moveToMenu} from "../module/ScrollModule";
import {textMap} from "../common/Localization";

import './MobileHeader.scss';

const MobileHeader = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	
	const dispatch = useDispatch();
	const showHeaderLine = useSelector(state => state.ScrollModule.showHeaderLine);

	const onClickMenu = useCallback((id) => {
		if(id === "topIntro") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-로고"
			});
		} else if(id === "whyMinimap1") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-왜미니맵인가요?"
			});
		} else if(id === "price") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-가격정보"
			});
		} else if(id === "faq") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-FAQ"
			});
		}
		setMenuOpen(false);
		dispatch(moveToMenu(id));
	}, [dispatch]);

	const onClickHamburger = useCallback(() => {
		setMenuOpen(!menuOpen);
	}, [menuOpen]);

	const sendGa = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"미니맵-문의",
			label:"헤더-문의하기"
		});
	}, []);
	const sendGa2 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"헤더-광고시작하기"
		});
	}, []);

	const closeHamburger = useCallback(() => {
		setMenuOpen(false);
	}, []);

	return (
		<>
			<div id="mobileHeader" className={classNames("bc_ff", showHeaderLine ? "lc_eb" : "lc_transparent")}>
				<div className="header_wrap">
					<img className="hamburger" src={process.env.PUBLIC_URL + "/icon/hamburger.png"} alt="" onClick={() => onClickHamburger()}/>
					<img className="logo" src={process.env.PUBLIC_URL + "/img/mobile_logo.png"} alt="" onClick={() => onClickMenu("topIntro")}/>
					<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa2}>
						<span className={classNames("start_button", "cbc_blue", "sc_blue", "c_ff", "t_13")}>{textMap.header_start_button}</span>
					</a>
				</div>
			</div>
			<div id="hamburgerWrap" className={classNames(menuOpen ? "open" : "")} onClick={closeHamburger}>
				<div className={classNames("menu_list", "bc_ff", "c_4a")}>
					<div className="tab_button" onClick={() => onClickMenu("whyMinimap1")}>{textMap.header_why}</div>
					<div className="tab_button" onClick={() => onClickMenu("price")}>{textMap.header_price}</div>
					<div className="tab_button" onClick={() => onClickMenu("faq")}>{textMap.header_faq}</div>
					<div className="tab_button"><a href="https://minimap.net/auth/help" target="_blank" rel="noopener noreferrer" onClick={sendGa}>{textMap.header_ask}</a></div>
				</div>
			</div>
		</>
	);
};

export default MobileHeader;
